import { useRef, useState, useEffect } from 'react';
import { HotTable, HotColumn } from '@handsontable/react-wrapper';
import { registerAllModules } from 'handsontable/registry';
import { FaEdit, FaTrash } from 'react-icons/fa';
import 'handsontable/styles/handsontable.css';
import 'handsontable/styles/ht-theme-main.css';
import 'handsontable/styles/ht-theme-horizon.css';

// register Handsontable's modules
registerAllModules();

// constants.ts
export const data = [
  [false, 'Tagcat', 'United Kingdom', 'Classic Vest', '16/05/2025', '01-2331942', true],
  [false, 'Zoomzone', 'Indonesia', 'Cycling Cap', '17/05/2025', '88-2768633', true],
];

const ActionButtons = ({ row, onEdit, onDelete }) => {
    return (
      <div className="d-flex gap-1">
        <button
            className="btn btn-md btn-outline-primary"
            onClick={() => onEdit(row)}>
            <FaEdit />
        </button>
        <button
            className="btn btn-md btn-outline-danger"
            onClick={() => onDelete(row)}>
            <FaTrash />
        </button>
      </div>
    );
  };

const ExampleComponent = () => {
  const hotRef = useRef(null);
  const [themeName, setThemeName] = useState(
    document.querySelector('html')?.classList.contains('theme-dark') ? 'ht-theme-horizon-dark' : 'ht-theme-horizon'
  );
  const [tableData, setTableData] = useState(data);

  const handleOnChange = (event) => {
    setThemeName(event.target.value);
  };

  useEffect(() => {
    if (!hotRef.current?.hotInstance) {
      return;
    }

    hotRef.current.hotInstance.useTheme(themeName);
    hotRef.current.hotInstance.render();
  }, [themeName]);

  const handleEdit = (visualRow) => {
    const instance = hotRef.current.hotInstance;
    if (!instance) return;
    const physicalRow = instance.toPhysicalRow(visualRow);
    console.log('Editing row:', physicalRow, tableData[physicalRow]);
    // Add your edit logic here
  };

  const handleDelete = (visualRow) => {
    const instance = hotRef.current.hotInstance;
    if (!instance) return;
    const physicalRow = instance.toPhysicalRow(visualRow);
    setTableData(prev => prev.filter((_, index) => index !== physicalRow));
  };
  

  return (
    <>
      <div className="mb-3">
        <div className="d-flex align-items-center gap-3">
            <select
            id="themeSelect"
            className="form-select w-auto"
            value={themeName}
            onChange={handleOnChange}
            >
            <option value="ht-theme-main">Main Light</option>
            <option value="ht-theme-horizon">Horizon Light</option>
            <option value="ht-theme-main-dark">Main Dark</option>
            <option value="ht-theme-horizon-dark">Horizon Dark</option>
            <option value="ht-no-theme">No theme</option>
            </select>

            <div className={`d-flex align-items-center gap-1 ${themeName}`}>
            <span
                className="rounded-circle border"
                style={{
                background: 'var(--ht-foreground-color)',
                width: '20px',
                height: '20px',
                }}
            />
            <span
                className="rounded-circle border"
                style={{
                background: 'var(--ht-background-color)',
                width: '20px',
                height: '20px',
                }}
            />
            <span
                className="rounded-circle border"
                style={{
                background: 'var(--ht-accent-color)',
                width: '20px',
                height: '20px',
                }}
            />
            </div>
        </div>
        </div>

      <HotTable
        key={themeName}
        ref={hotRef}
        data={data}
        height={450}
        // colWidths={[180, 220, 140, 120, 120, 120, 140, 120, 120]}
        colHeaders={['Company Name', 'Name', 'Sell date', 'In stock', 'Quantity', 'Order ID', 'Country', 'Actions']}
        contextMenu={[
          'copy',
          '---------',
          'row_above',
          'row_below',
          'remove_row',
          '---------',
          'alignment',
          'make_read_only',
          'clear_column',
        ]}
        dropdownMenu={true}
        hiddenColumns={{
          indicators: true,
        }}
        multiColumnSorting={true}
        filters={true}
        rowHeaders={true}
        headerClassName="htLeft"
        manualRowMove={true}
        autoWrapRow={true}
        autoWrapCol={true}
        manualRowResize={true}
        manualColumnResize={true}
        navigableHeaders={true}
        autoColumnSize={true}
        licenseKey="non-commercial-and-evaluation"
      >
        <HotColumn data={1} />
        <HotColumn data={3} />
        <HotColumn data={4} type="date" allowInvalid={false} />
        <HotColumn data={6} type="checkbox" className="htCenter" />
        <HotColumn data={7} type="numeric" />
        <HotColumn data={5} />
        <HotColumn data={2} />
        
        {/* Action column with React component */}
        <HotColumn
          readOnly={true}
          filters={false}
          renderer={(props) => (
            <ActionButtons
              row={props.row}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          )}
        />
      </HotTable>
    </>
  );
};

export default ExampleComponent;